import { createRoute, Outlet } from '..';
import { layoutRouteId } from '../definePath';
import { Route as rootRoute } from './__root';

export const Route = createRoute({
  id: layoutRouteId('bare'),
  getParentRoute: () => rootRoute,
  component: () => <Outlet />,
});
